import Http from 'common/services/Http';
import { GeofenceActivitiesDto } from './models/GeofenceActivitiesDto';
import { Paged } from 'api/common/types/Page';
import { GeofenceActivitiesConterDto } from './models/GeofenceActivitiesConterDto';
import { GeofenceActivitiesSearchCriteria } from './models/GeofenceActivitiesSearchCriteria';


class GeofenceActivitiesService {

    public getList(criteria: GeofenceActivitiesSearchCriteria) {
        return Http.get<Paged<GeofenceActivitiesDto>>('geofenceactivities', criteria);
    }

    public getCounters(criteria: GeofenceActivitiesSearchCriteria) {
        return Http.get<GeofenceActivitiesConterDto>('geofenceactivities/counters-list', criteria);
    }

    
}

export default new GeofenceActivitiesService();
